// Constants for calculations
const NORTHSOUTH_KM: number = 111; // 1 degree of latitude in kilometers
const EASTWEST_KM: number = 91; // Adjusted for latitude in your context
const EARTHCIRCUMFERENCE: number = 40075; // Earth's circumference in kilometers

// Common function to compute map center and zoom level
type LatLngLiteral = {
  lat: number;
  lng: number;
};
export const calculateMapProperties = (dateList: LatLngLiteral[]) => {
  if (!dateList) return { zoom: 0, center: { lat: 0, lng: 0 } };

  const locations = dateList.map((item) => ({
    latitude: Number(item.lat),
    longitude: Number(item.lng),
  }));

  // Compute min and max for latitude and longitude
  const latitudes = locations.map((loc: { latitude: number }) => loc.latitude);
  const longitudes = locations.map((loc: { longitude: number }) => loc.longitude);
  const maxLatitude = Math.max(...latitudes);
  const minLatitude = Math.min(...latitudes);
  const maxLongitude = Math.max(...longitudes);
  const minLongitude = Math.min(...longitudes);

  // Calculate average latitude and longitude to determine center
  const avgLatitude = (maxLatitude + minLatitude) / 2;
  const avgLongitude = (maxLongitude + minLongitude) / 2;

  // Calculate distances to determine zoom level
  const northSouthDistance = (maxLatitude - minLatitude) * NORTHSOUTH_KM;
  const eastWestDistance = (maxLongitude - minLongitude) * EASTWEST_KM;
  const distance = Math.max(northSouthDistance, eastWestDistance) * 1.3;

  // Calculate zoom level
  const zooms = Math.round(Math.log2(EARTHCIRCUMFERENCE / distance));

  return { zooms, centers: { lat: avgLatitude, lng: avgLongitude } };
};
